var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrinter3D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 59,
    viewBox: "0 0 53 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.46797 2.99982H8.80675V4.5C8.80675 6.98511 10.7784 9 13.2101 9H39.6304C42.0627 9 44.0337 6.98511 44.0337 4.5V2.99982H51.3731C52.1836 2.99982 52.8405 2.32855 52.8405 1.50018C52.8405 0.671814 52.1836 0 51.3731 0H1.46797C0.657389 0 0 0.671814 0 1.50018C0 2.32855 0.657389 2.99982 1.46797 2.99982Z",
    fill: "#40336F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9112 35C27.3009 35 27.6739 34.8505 27.9497 34.5837C28.2249 34.3165 28.3792 33.9549 28.3792 33.5772V31.8929C30.1336 31.2937 31.3092 29.6896 31.3146 27.887V26C30.3653 26.2938 29.3757 26.4501 28.3792 26.4642H25.4438C24.4467 26.4501 23.4576 26.2938 22.5078 26V27.887C22.5137 29.6896 23.6893 31.2937 25.4438 31.8929V33.5772C25.4432 33.9549 25.598 34.3165 25.8732 34.5837C26.1484 34.8505 26.522 35 26.9112 35Z",
    fill: "#40336F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3731 55.9997H4.40337C3.59279 55.9997 2.93594 55.3284 2.93594 54.5001C2.93594 53.6717 3.59279 52.9999 4.40337 52.9999H42.5663C44.9981 52.9999 46.9697 50.9851 46.9697 48.5C46.9697 46.0149 44.9981 44.0001 42.5663 44.0001H29.3562C28.5456 44.0001 27.8882 43.3283 27.8882 42.4999V39.5002C27.8882 38.6718 27.2308 38 26.4202 38C25.6097 38 24.9528 38.6718 24.9528 39.5002V42.4999C24.9528 44.9855 26.9239 46.9998 29.3562 46.9998H42.5663C43.3769 46.9998 44.0337 47.6716 44.0337 48.5C44.0337 49.3284 43.3769 50.0002 42.5663 50.0002H4.40337C1.97163 50.0002 0 52.0145 0 54.5001C0 56.9851 1.97163 59 4.40337 59H51.3731C52.1836 59 52.8405 58.3282 52.8405 57.4998C52.8405 56.6715 52.1836 55.9997 51.3731 55.9997Z",
    fill: "#F1805E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2229 15.8749V11H17.6094V15.8749C17.6094 20.3623 20.8952 24 24.9487 24H27.8841C31.9375 24 35.2229 20.3623 35.2229 15.8749Z",
    fill: "#40336F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinter3D);
export default __webpack_public_path__ + "static/media/printer_3d.cf3f3bcc57ab6f4f437cdef14acc7a33.svg";
export { ForwardRef as ReactComponent };